import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PasswordService } from 'src/app/services/password.service';
import { checkError, CONSTANTES, getToken, PasswordValidator } from 'src/app/shared/global';


declare var jQuery: any;

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  public userName: string;
  public password: string;
  public password2: string;
  public password3: string;
  public forcedChangePassword: boolean;
  //public token: string;

  // validación campos formulario
  public formChangePassword = new FormGroup({
    password: new FormControl("", [Validators.required]),
    password2: new FormControl("", [Validators.required, PasswordValidator.strong]),
    password3: new FormControl("", [Validators.required, PasswordValidator.strong]),
  });

  constructor(private toastr: ToastrService, private passwordService: PasswordService, private authService: AuthenticationService, 
    private router: Router, private Spinner: NgxSpinnerService,) { }

  ngOnInit() {
    jQuery.getScript(CONSTANTES.menu);    
    this.forcedChangePassword= localStorage.getItem("forcedChangePassword") === "true";
    if (this.forcedChangePassword === true)
      this.formChangePassword.get("password").setValue(localStorage.getItem("nid"));
    this.Spinner.hide();
  }
  changePassword() {

    let datos = {
      userName: localStorage.getItem("nid"),
      //currentPassword: (this.forcedChangePassword === true ? localStorage.getItem("nid") : this.formChangePassword.value["password"]),
      currentPassword: this.formChangePassword.value["password"],
      pwd1: String,
      pwd2: String,
    }
    datos.pwd1 = this.formChangePassword.value["password2"];
    datos.pwd2 = this.formChangePassword.value["password3"];

    if (datos.pwd1 == datos.pwd2) {
      if ((datos.currentPassword != datos.pwd1) && (datos.pwd1.toString().substring(2, 6) != datos.currentPassword.toString().substring(2, 6))) {
        this.passwordService.changePassword(datos).subscribe(
          data => {
            if (getToken(data)) {

              if (data.errorCode.code != "E_STATUS_OK") {
                this.toastr.warning(data.errorCode.message, "ERROR");
              } else {
                this.toastr.success('SU CONTRASEÑA HA SIDO MODIFICADA CORRECTAMENTE');
                let infoUser = {
                  userName: localStorage.getItem("nid")
                }
                this.authService.logOut(infoUser).subscribe(
                  data => {
                    localStorage.clear();
                    this.router.navigate(['login']);
                  }
                );
              }
            } else {
              //this.toastr.warning(data.errorCode.message, "ERROR");
              //this.toastr.warning('Los datos que ha introducido para cambiar su contraseña no son correctos');
              if (!checkError(data.errorCode.code)) {
                let infoUser = {
                  userName: localStorage.getItem("nid")
                }
                this.authService.logOut(infoUser).subscribe(
                  data => {
                    localStorage.clear();
                    this.router.navigate(['login']);
                  }
                );
              }
            }
          },
          error => {
            this.toastr.warning('NO SE HA MODIFICADO LA CONTRASEÑA');
          });
      } else {
        this.toastr.warning('LA CONTRASEÑA NUEVA ES IGUAL O MUY SIMILAR A LA ACTUAL');
      }
    } else {
      this.toastr.warning('LAS CONTRASEÑAS NO COINCIDEN');
    }
  }

}


